export const remainTime = timestamp => {
    var delta = timestamp - Math.floor(Date.now())
    let seconds = Math.floor((delta / 1000) % 60)
    let minutes = Math.floor((delta / (1000 * 60)) % 60)
    let hours = Math.floor((delta / (1000 * 60 * 60)) % 24)
    let days = Math.floor(delta / (1000 * 60 * 60 * 24))
    return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        delta: delta,
    }
}